<template>
  <span :class="{ spanClass: spanClass, 'direction-ltr': getAppLang === 'en' }">
    <span v-if="getAppLang === 'en'">
      {{ timerDuration | formatTime(persianTimer ? persianTimer : false) }}
    </span>
    <span v-else>
      {{
        timerDuration
          | formatTime(persianTimer ? persianTimer : false)
          | persianDigit
      }}
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Timer",
  props: {
    duration: {
      type: Number,
      required: true,
    },
    //separating the timers for multiple usage in one component.
    timerKey: {
      type: String,
      required: true,
    },
    spanClass: String,
    persianTimer: Boolean,
  },
  data() {
    return {
      timerDuration: null,
      countDownInterval: null,
    };
  },
  computed: {
    ...mapGetters(["getAppLang"]),
  },
  methods: {
    timerExpiredEvent() {
      this.$emit("expired");
    },
    activeInterval() {
      if (this.countDownInterval) clearInterval(this.countDownInterval);
      this.initValues();
      this.countDownInterval = setInterval(this.countDownFunc, 1000);
    },
    clearInterval() {
      clearInterval(this.countDownInterval);
      this.countDownInterval = null;
    },
    countDownFunc() {
      if (this.timerDuration <= 0) {
        this.timerExpiredEvent();
        this.clearInterval();
        this.timerDuration = 0;
      } else this.timerDuration -= 1000;
    },
    initValues() {
      this.timerDuration = this.duration;
    },
  },
  created() {
    // this.activeInterval();
  },
  mounted() {
    // this.$parent.$on(`activateTimer${this.timerKey}`, this.activeInterval);
    // this.$parent.$on(`deactivateTimer${this.timerKey}`, this.clearInterval);
  },
  beforeDestroy() {
    // this.$parent.$off(`activateTimer${this.timerKey}`, this.clearInterval);
    // this.$parent.$off(`deactivateTimer${this.timerKey}`, this.clearInterval);
  },
  destroyed() {
    this.clearInterval();
  },
};
</script>

<style scoped></style>
